import React from 'react';
import {routePermittedRole} from 'shared/constants/AppConst';
import Account from './MyProfile';

export const accountPagesConfigs = [
  {
    permittedRole: routePermittedRole.user,
    path: '/my-profile',
    element: <Account />,
  },
];
